import { useEffect, useState } from 'react';
import { subscribePartnerInvites, subscribePartnerUsers } from '@/data/invitesRepo';
import type { InviteType } from '@/types/types_invite';
import type { PartnerUserType } from '@/types/types_partnerUser';

// Both hooks mirror usePartners.ts: subscribe on mount, set state only from the
// snapshot callback. They take a required partnerId — every caller renders
// inside a resolved partner context.

/** Subscribes to one partner's invitations, newest first. */
export function usePartnerInvites(partnerId: string) {
  const [invites, setInvites] = useState<InviteType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return subscribePartnerInvites(
      partnerId,
      (list) => {
        setInvites(list);
        setLoading(false);
        setError(null);
      },
      (e) => {
        console.error('Invite subscription failed', e);
        setError('Could not load invitations.');
        setLoading(false);
      },
    );
  }, [partnerId]);

  return { invites, loading, error };
}

/** Subscribes to the accounts belonging to one partner. */
export function usePartnerUsers(partnerId: string) {
  const [partnerUsers, setPartnerUsers] = useState<PartnerUserType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return subscribePartnerUsers(
      partnerId,
      (list) => {
        setPartnerUsers(list);
        setLoading(false);
      },
      (e) => {
        console.error('Partner user subscription failed', e);
        setLoading(false);
      },
    );
  }, [partnerId]);

  return { partnerUsers, loading };
}
